import { AlASIClient } from '@al/asi';
import { AlViewHelperComponent } from '@al/ng-generic-components';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'signup-activate',
  templateUrl: './signup-activate.component.html',
  styleUrls: [ './signup-activate.component.scss' ]
})

export class SignupActivateComponent implements OnInit {
    
    title: string = '';
    descriptions: string[] = [];
    showContactSupport: boolean = false;
    showSteps: boolean = false;
    loading: boolean = false;

    @ViewChild(AlViewHelperComponent) viewHelper: AlViewHelperComponent;
    constructor(private activatedRoute: ActivatedRoute) {}

    ngOnInit(): void {
        this.activatedRoute.paramMap.subscribe((param: Params) => {
            this.activate(param.get('product'), param.get('token'));
        });
    }

    async activate(productType: string, token: string) {
        if(productType && token){
            this.loading = true;
            try {
                productType = productType === 'asi' ? "tmaw" : productType;
                await AlASIClient.activateAccount(token);
                switch (productType) {
                    case 'siemless':
                    case 'cigd':
                        this.title = 'Thanks for signing up';
                        const productText = productType === 'siemless' ? 'SIEMless Threat Management' : 'Cloud Insight Essentials';
                        this.descriptions = [
                            `You can start using ${productText} as soon as you receive your ${productText} welcome email and follow the included instructions.`
                        ];
                        this.showContactSupport = true;
                        break;
                    case 'tmaw':
                        this.title = 'Activating Account';
                        this.descriptions = [
                            'Alert Logic is activating your account.',
                            'Alert Logic will send an email message to you that contains your user credentials and instructions for managing your service. If you do not receive the email message, check your spam folder.',
                            'Activating your account has completed the 2nd step toward setting up Threat Manager.'
                        ];
                        this.showSteps = true;
                        this.showContactSupport = true;
                        break;
                    default:
                        this.title = 'Thanks for signing up';
                        this.descriptions = [
                            'Thank you for choosing Cloud Defender. As part of your subscription you have access to Cloud Insight.' 
                            + ' An Alert Logic onboarding manager will contact you within two business days to complete your Cloud Defender deployment.',
                            'You can start using Cloud Insight as soon as you receive your Cloud Insight welcome email and follow the included instructions.'
                        ];
                        this.showSteps = false;
                        this.showContactSupport = true;
                        break;
                }
            } catch (error){
                this.manageError(error)
            } finally {
                this.loading = false;
            }
        }
    }

    manageError(error){
        switch (error.status) {
            case 400:
                this.title = 'Your account could not be activated';
                this.descriptions = [
                    'We are sorry but there was an unexpected error while activating your account.'
                ];
                const msg = error.data && error.data.error ? error.data.error : 'unhandled_error';
                this.viewHelper.notifyError(`Error details: ${msg}`, 0);
                this.showContactSupport = true;
                break;
            case 404:
                this.title = 'Your account could not be activated';
                this.descriptions = [
                    'We are sorry but the activation process failed. The provided security token does not seem to be valid.'
                ];
                this.showContactSupport = true;
                break;
            case 410:
                this.title = 'Your account could not be activated.';
                this.descriptions = [
                    'We are sorry but the activation process failed. It seems the activation link has expired.'
                ];
                this.showContactSupport = true;
                break;
            default:
                break;
        }        
    }
}
